<template>
	<a
		tabindex="0"
		href="#"
		class="header-link"
		@click.prevent="
			$emit('input', value === descValue ? ascValue : descValue)
		"
	>
		{{ label }}
		<span v-if="value === descValue">▼</span>
		<span v-if="value === ascValue">▲</span>
	</a>
</template>
<script>
	export default {
		name: 'HeaderLink',
		props: {
			label: {
				type: String,
				required: true,
			},
			value: {
				type: Number,
				required: true,
			},
			descValue: {
				type: Number,
				required: true,
			},
			ascValue: {
				type: Number,
				required: true,
			},
		},
	};
</script>
<style lang="scss" scoped>
	A.header-link {
		font-weight: bolder;
		color: $btn-blue;
	}
</style>
